export default __webpack_public_path__ + "static/media/domki13.83d25416.jpg";